export default __webpack_public_path__ + "static/media/Logoff.dce8499a.svg";